(() => {
  if (window.TFGCartCrossSellLoaded) return;
  window.TFGCartCrossSellLoaded = true;

  const MODULE_SELECTOR = '[data-tfg-cart-cross-sell]';
  const MOUNT_SELECTOR = '[data-tfg-cart-cross-sell-mount]';
  const CACHE_MS = 3 * 60 * 1000;
  const MAX_RECOMMENDATIONS = 12;

  let cachedPairings = null;
  let cachedPairingsAt = 0;
  let initTimer = null;

  const FALLBACK_PAIRINGS = [
    {
      enabled: 'TRUE',
      priority: '10',
      type: 'bog',
      source_handle: 'bowl-o-gainz-cream-pie',
      source_title: 'Cream Pie',
      target_handle: 'bowl-o-gainz-crackberry',
      target_title: 'Crackberry',
      label: 'Fruit & Cream Pack',
      description: 'Cream Pie keeps it smooth. Crackberry brings the berry punch.',
      best_for: 'Breakfast bowls, fruit bowls, creamy dessert bowls',
      placement: 'both',
    },
    {
      enabled: 'TRUE',
      priority: '20',
      type: 'bog',
      source_handle: 'bowl-o-gainz-crackberry',
      source_title: 'Crackberry',
      target_handle: 'bowl-o-gainz-cream-pie',
      target_title: 'Cream Pie',
      label: 'Fruit & Cream Pack',
      description: 'Crackberry brings the berry hit. Cream Pie smooths it out.',
      best_for: 'Breakfast bowls, fruit bowls, creamy dessert bowls',
      placement: 'both',
    },
    {
      enabled: 'TRUE',
      priority: '30',
      type: 'sauce',
      source_handle: 'smv-sauce',
      source_title: 'SMV Sauce',
      target_handle: 'sweet-papi',
      target_title: 'Sweet Papi',
      label: 'Sweet Heat Duo',
      description: 'SMV brings the punch. Sweet Papi brings bold sweet heat for everyday meals.',
      best_for: 'Eggs, chicken, rice, steak, burgers, wraps, veggies, seafood',
      placement: 'both',
    },
    {
      enabled: 'TRUE',
      priority: '40',
      type: 'sauce',
      source_handle: 'sweet-papi',
      source_title: 'Sweet Papi',
      target_handle: 'smv-sauce',
      target_title: 'SMV Sauce',
      label: 'Sweet Heat Duo',
      description: 'Sweet Papi brings the sweet heat. SMV gives you the everyday sauce flex.',
      best_for: 'Eggs, chicken, rice, steak, burgers, wraps, veggies, seafood',
      placement: 'both',
    },
    {
      enabled: 'TRUE',
      priority: '50',
      type: 'sauce',
      source_handle: 'southwest-smash-sauce-chipotle-aioli',
      source_title: 'Southwest Smash Sauce [Chipotle Aioli]',
      target_handle: 'sweet-papi',
      target_title: 'Sweet Papi',
      label: 'Burger Night Duo',
      description: 'Creamy chipotle meets bold sweet heat. No dry sandwich energy here.',
      best_for: 'Burgers, chicken sandwiches, wraps, fries, grilled chicken, turkey burgers',
      placement: 'both',
    },
    {
      enabled: 'TRUE',
      priority: '60',
      type: 'sauce',
      source_handle: 'take-out-sauce',
      source_title: 'Take-Out Sauce',
      target_handle: 'smv-sauce',
      target_title: 'SMV Sauce',
      label: 'Meal Prep Hero Duo',
      description: 'Take-Out builds the bowl. SMV brings the sweet-spicy punch.',
      best_for: 'Chicken, beef, eggs, rice bowls, stir-fry, salmon, veggies',
      placement: 'both',
    },
    {
      enabled: 'TRUE',
      priority: '70',
      type: 'bog',
      source_handle: 'bowl-o-gainz-brownie-batter-watch-recipe-video',
      source_title: 'Brownie Batter',
      target_handle: 'bowl-o-gainz-caramel-coconut-fudge-cookie-summo',
      target_title: 'SumMo',
      label: 'Chocolate Cravings Pack',
      description: 'Brownie Batter brings the chocolate. SumMo brings caramel coconut cookie chaos.',
      best_for: 'Dessert bowls, late-night cravings, sweet meal prep',
      placement: 'both',
    },
  ];

  function scheduleInit(delay = 150) {
    window.clearTimeout(initTimer);
    initTimer = window.setTimeout(initAll, delay);
  }

  function parseCsv(text) {
    const rows = [];
    let row = [];
    let field = '';
    let inQuotes = false;

    for (let i = 0; i < text.length; i += 1) {
      const char = text[i];
      const next = text[i + 1];

      if (char === '"' && inQuotes && next === '"') {
        field += '"';
        i += 1;
        continue;
      }

      if (char === '"') {
        inQuotes = !inQuotes;
        continue;
      }

      if (char === ',' && !inQuotes) {
        row.push(field);
        field = '';
        continue;
      }

      if ((char === '\n' || char === '\r') && !inQuotes) {
        if (char === '\r' && next === '\n') i += 1;

        row.push(field);

        if (row.some((value) => String(value).trim() !== '')) {
          rows.push(row);
        }

        row = [];
        field = '';
        continue;
      }

      field += char;
    }

    row.push(field);

    if (row.some((value) => String(value).trim() !== '')) {
      rows.push(row);
    }

    if (!rows.length) return [];

    const headers = rows.shift().map((header) => String(header).trim());

    return rows.map((values) => {
      return headers.reduce((entry, header, index) => {
        entry[header] = String(values[index] || '').trim();
        return entry;
      }, {});
    });
  }

  function isEnabled(value) {
    return ['true', 'yes', '1', 'enabled'].includes(
      String(value || '').trim().toLowerCase()
    );
  }

  function normalizePlacement(value) {
    return String(value || '').trim().toLowerCase();
  }

  function placementMatches(rowPlacement, modulePlacement) {
    const rowValue = normalizePlacement(rowPlacement);
    const moduleValue = normalizePlacement(modulePlacement);

    if (!rowValue) return true;
    if (rowValue === 'both') return true;
    if (rowValue === 'all') return true;

    return rowValue === moduleValue;
  }

  function normalizePairings(rows) {
    return rows
      .filter((row) => isEnabled(row.enabled))
      .filter((row) => row.source_handle && row.target_handle)
      .sort((a, b) => Number(a.priority || 9999) - Number(b.priority || 9999));
  }

  function getPairingsUrl(url) {
    if (!url) return '';
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}_tfg=${Math.floor(Date.now() / CACHE_MS)}`;
  }

  async function getPairings(url) {
    const now = Date.now();

    if (cachedPairings && now - cachedPairingsAt < CACHE_MS) {
      return cachedPairings;
    }

    try {
      const response = await fetch(getPairingsUrl(url), {
        method: 'GET',
        credentials: 'omit',
        cache: 'no-store',
        headers: {
          Accept: 'text/csv,text/plain,*/*',
        },
      });

      if (!response.ok) throw new Error('Google Sheet CSV did not load.');

      const text = await response.text();
      const sheetPairings = normalizePairings(parseCsv(text));

      cachedPairings = sheetPairings.length
        ? sheetPairings
        : normalizePairings(FALLBACK_PAIRINGS);

      cachedPairingsAt = now;

      return cachedPairings;
    } catch (error) {
      console.warn('[TFG cart cross-sell] Using fallback pairings.', error);

      cachedPairings = normalizePairings(FALLBACK_PAIRINGS);
      cachedPairingsAt = now;

      return cachedPairings;
    }
  }

  async function getCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) throw new Error('Unable to load cart.');

    return response.json();
  }

  async function getProduct(handle) {
    if (!handle) return null;

    const response = await fetch(`/products/${handle}.js`, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      console.warn(`[TFG cart cross-sell] Product not found: ${handle}`);
      return null;
    }

    return response.json();
  }

  function getAvailableVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;
    return product.variants.find((variant) => variant.available) || null;
  }

  function formatMoney(cents, moneyFormat) {
    const format = moneyFormat || '${{amount}}';
    const value = Number(cents || 0) / 100;

    const amount = value.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const amountNoDecimals = Math.round(value).toLocaleString();

    const amountWithCommaSeparator = amount
      .replace(/,/g, 'TEMP')
      .replace(/\./g, ',')
      .replace(/TEMP/g, '.');

    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithCommaSeparator)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getImage(product, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }

    if (product && product.featured_image) {
      return product.featured_image;
    }

    if (product && Array.isArray(product.images) && product.images.length) {
      return product.images[0];
    }

    return '';
  }

  function getCartHandles(cart) {
    return new Set((cart.items || []).map((item) => item.handle).filter(Boolean));
  }

  function getCartHandleRank(cart) {
    const rank = new Map();

    (cart.items || []).forEach((item, index) => {
      if (item.handle && !rank.has(item.handle)) {
        rank.set(item.handle, index);
      }
    });

    return rank;
  }

  function findMatchingRows(pairings, cart, placement) {
    const cartHandles = getCartHandles(cart);
    const cartHandleRank = getCartHandleRank(cart);
    const seenTargets = new Set();

    const matches = pairings.filter((row) => {
      if (!placementMatches(row.placement, placement)) return false;
      if (!cartHandles.has(row.source_handle)) return false;
      if (cartHandles.has(row.target_handle)) return false;
      if (seenTargets.has(row.target_handle)) return false;

      seenTargets.add(row.target_handle);
      return true;
    });

    matches.sort((a, b) => {
      const aCartRank = cartHandleRank.has(a.source_handle)
        ? cartHandleRank.get(a.source_handle)
        : 9999;

      const bCartRank = cartHandleRank.has(b.source_handle)
        ? cartHandleRank.get(b.source_handle)
        : 9999;

      if (aCartRank !== bCartRank) return aCartRank - bCartRank;

      return Number(a.priority || 9999) - Number(b.priority || 9999);
    });

    return matches;
  }

  async function findRecommendations(pairings, cart, placement) {
    const matches = findMatchingRows(pairings, cart, placement);
    const recommendations = [];

    for (const row of matches) {
      if (recommendations.length >= MAX_RECOMMENDATIONS) break;

      const product = await getProduct(row.target_handle);
      const variant = getAvailableVariant(product);

      if (product && variant) {
        recommendations.push({
          row,
          product,
          variant,
        });
      }
    }

    return recommendations;
  }

  function renderRecommendationCard(recommendation, moneyFormat, placement) {
    const { row, product, variant } = recommendation;
    const image = getImage(product, variant);
    const productUrl = `/products/${product.handle}`;
    const isNotification = placement === 'cart_notification';
    const sourceTitle = row.source_title || row.source_handle || 'this item';

    return `
      <div class="tfg-cart-cross-sell__slide">
        <div class="tfg-cart-cross-sell__card" data-tfg-cart-cross-sell-card>
          <a
            class="tfg-cart-cross-sell__image"
            href="${escapeHtml(productUrl)}"
            aria-label="View ${escapeHtml(product.title)}"
          >
            ${
              image
                ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" loading="lazy" width="${isNotification ? 72 : 92}" height="${isNotification ? 72 : 92}">`
                : ''
            }
          </a>

          <div class="tfg-cart-cross-sell__content">
            <div class="tfg-cart-cross-sell__source">
              Pairs with ${escapeHtml(sourceTitle)}
            </div>

            <div class="tfg-cart-cross-sell__top">
              <a class="tfg-cart-cross-sell__title" href="${escapeHtml(productUrl)}">
                ${escapeHtml(product.title)}
              </a>

              <span class="tfg-cart-cross-sell__price">
                ${formatMoney(variant.price, moneyFormat)}
              </span>
            </div>

            ${row.label ? `<div class="tfg-cart-cross-sell__label">${escapeHtml(row.label)}</div>` : ''}

            ${row.description ? `<p class="tfg-cart-cross-sell__description">${escapeHtml(row.description)}</p>` : ''}

            ${row.best_for ? `<p class="tfg-cart-cross-sell__best-for">Best for: ${escapeHtml(row.best_for)}</p>` : ''}

            <button
              type="button"
              class="tfg-cart-cross-sell__button"
              data-tfg-cart-cross-sell-add
              data-variant-id="${variant.id}"
              data-source-handle="${escapeHtml(row.source_handle)}"
              data-target-handle="${escapeHtml(row.target_handle)}"
            >
              Add to cart
            </button>
          </div>
        </div>
      </div>
    `;
  }

  function bindSlider(container) {
    const slider = container.querySelector('[data-tfg-cart-cross-sell-slider]');
    const prev = container.querySelector('[data-tfg-cart-cross-sell-prev]');
    const next = container.querySelector('[data-tfg-cart-cross-sell-next]');

    if (!slider || !prev || !next) return;

    const updateButtons = () => {
      const maxScroll = slider.scrollWidth - slider.clientWidth - 2;
      prev.disabled = slider.scrollLeft <= 2;
      next.disabled = slider.scrollLeft >= maxScroll;
    };

    const scrollAmount = () => {
      const slide = slider.querySelector('.tfg-cart-cross-sell__slide');
      return slide ? slide.getBoundingClientRect().width + 16 : slider.clientWidth * 0.85;
    };

    prev.addEventListener('click', () => {
      slider.scrollBy({
        left: -scrollAmount(),
        behavior: 'smooth',
      });
    });

    next.addEventListener('click', () => {
      slider.scrollBy({
        left: scrollAmount(),
        behavior: 'smooth',
      });
    });

    slider.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    window.setTimeout(updateButtons, 80);
  }

  function renderRecommendations(container, recommendations) {
    const mount = container.querySelector(MOUNT_SELECTOR);
    const moneyFormat = container.dataset.moneyFormat;
    const placement = normalizePlacement(container.dataset.placement);

    if (!mount) return;

    const cards = recommendations
      .map((recommendation) => renderRecommendationCard(recommendation, moneyFormat, placement))
      .join('');

    mount.innerHTML = `
      <div class="tfg-cart-cross-sell__slider-shell">
        <button
          type="button"
          class="tfg-cart-cross-sell__arrow tfg-cart-cross-sell__arrow--prev"
          data-tfg-cart-cross-sell-prev
          aria-label="Previous recommendation"
        >
          ‹
        </button>

        <div
          class="tfg-cart-cross-sell__slider"
          data-tfg-cart-cross-sell-slider
          role="list"
        >
          ${cards}
        </div>

        <button
          type="button"
          class="tfg-cart-cross-sell__arrow tfg-cart-cross-sell__arrow--next"
          data-tfg-cart-cross-sell-next
          aria-label="Next recommendation"
        >
          ›
        </button>
      </div>
    `;

    container.hidden = false;
    bindSlider(container);
  }

  function hideContainer(container) {
    const mount = container.querySelector(MOUNT_SELECTOR);
    if (mount) mount.innerHTML = '';
    container.hidden = true;
  }

  async function initContainer(container) {
    if (!container) return;

    try {
      const placement = normalizePlacement(container.dataset.placement || 'cart_page');

      const [pairings, cart] = await Promise.all([
        getPairings(container.dataset.pairingsUrl),
        getCart(),
      ]);

      if (!cart || !cart.items || !cart.items.length) {
        hideContainer(container);
        return;
      }

      const recommendations = await findRecommendations(pairings, cart, placement);

      if (!recommendations.length) {
        hideContainer(container);
        return;
      }

      renderRecommendations(container, recommendations);
    } catch (error) {
      console.warn('[TFG cart cross-sell]', error);
      hideContainer(container);
    }
  }

  function initAll() {
    document.querySelectorAll(MODULE_SELECTOR).forEach((container) => {
      initContainer(container);
    });
  }

  function getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');

    if (!selector) return parsed.body.innerHTML;

    const element = parsed.querySelector(selector);

    return element ? element.innerHTML : parsed.body.innerHTML;
  }

  function replaceSection(sectionHtml, targetId, selector) {
    const target = document.getElementById(targetId);
    if (!target || !sectionHtml) return false;

    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const newContent = selector ? parsed.querySelector(selector) : parsed.body;

    if (!newContent) return false;

    const currentContent = selector ? target.querySelector(selector) : target;

    if (currentContent) {
      currentContent.innerHTML = newContent.innerHTML;
      return true;
    }

    target.innerHTML = getSectionInnerHTML(sectionHtml, selector);
    return true;
  }

  function getSectionsToRender() {
    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (mainCartItems) {
      return [
        {
          id: 'main-cart-items',
          section: mainCartItems.dataset.id || 'main-cart-items',
          selector: '.js-contents',
        },
        {
          id: 'main-cart-footer',
          section:
            mainCartFooter && mainCartFooter.dataset.id
              ? mainCartFooter.dataset.id
              : 'main-cart-footer',
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }

    return [
      {
        id: 'cart-notification-product',
        section: 'cart-notification-product',
        selector: '.shopify-section',
      },
      {
        id: 'cart-notification-button',
        section: 'cart-notification-button',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  function getSectionIds() {
    return getSectionsToRender().map((section) => section.section);
  }

  function replaceSections(parsedState) {
    if (!parsedState || !parsedState.sections) return false;

    let replacedAnySection = false;

    getSectionsToRender().forEach((section) => {
      const sectionHtml = parsedState.sections[section.section];

      if (!sectionHtml) return;

      const replaced = replaceSection(sectionHtml, section.id, section.selector);

      if (replaced) replacedAnySection = true;
    });

    return replacedAnySection;
  }

  async function refreshAfterAdd(parsedState) {
    const cartNotification = document.querySelector('cart-notification');

    if (
      cartNotification &&
      typeof cartNotification.renderContents === 'function' &&
      parsedState &&
      parsedState.sections &&
      parsedState.sections['cart-notification-product'] &&
      !document.getElementById('main-cart-items')
    ) {
      cartNotification.renderContents(parsedState);
      scheduleInit(300);
      return;
    }

    const didReplace = replaceSections(parsedState);

    if (didReplace) {
      scheduleInit(300);
      return;
    }

    window.location.reload();
  }

  async function addUpsellToCart(button) {
    const variantId = button.dataset.variantId;

    if (!variantId || button.disabled) return;

    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          sections: getSectionIds(),
          sections_url: window.location.pathname,
        }),
      });

      const parsedState = await response.json();

      if (!response.ok) {
        throw new Error(parsedState.description || parsedState.message || 'Unable to add item.');
      }

      await refreshAfterAdd(parsedState);
    } catch (error) {
      console.warn('[TFG cart cross-sell]', error);

      button.disabled = false;
      button.textContent = 'Try again';

      window.setTimeout(() => {
        if (!button.disabled) button.textContent = originalText;
      }, 1800);
    }
  }

  function patchCartNotification() {
    const CartNotificationElement = window.customElements.get('cart-notification');

    if (!CartNotificationElement || CartNotificationElement.prototype.__tfgCrossSellPatched) return;

    const originalRenderContents = CartNotificationElement.prototype.renderContents;

    CartNotificationElement.prototype.renderContents = function patchedRenderContents(parsedState) {
      originalRenderContents.call(this, parsedState);
      scheduleInit(300);
    };

    CartNotificationElement.prototype.__tfgCrossSellPatched = true;
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-tfg-cart-cross-sell-add]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    addUpsellToCart(button);
  });

  document.addEventListener('DOMContentLoaded', () => {
    patchCartNotification();
    scheduleInit(150);
  });

  window.addEventListener('load', () => {
    patchCartNotification();
    scheduleInit(150);
  });

  window.TFGCartCrossSell = {
    init: initAll,
    clearCache() {
      cachedPairings = null;
      cachedPairingsAt = 0;
    },
  };
})();